// src/pages/ChangePassword.jsx
import React, { useState } from 'react';
import { useCommands } from '../api/commands';
import { useAuth } from '../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';

export default function ChangePassword() {
  const cmd = useCommands();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg('');

    if (!oldPass || !newPass) {
      setMsg('Please fill in all fields.');
      return;
    }
    if (newPass !== confirmPass) {
      setMsg('New passwords do not match.');
      return;
    }

    try {
      setLoading(true);
      await cmd.auth.changePassword(oldPass, newPass);
      setMsg('Password changed successfully. You will be logged out.');
      setTimeout(() => {
        logout();
        navigate('/login');
      }, 1800);
    } catch (e) {
      setMsg(e?.response?.data?.error || e.message || 'Failed to change password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container" style={{ maxWidth: 480 }}>
      <PageHeader eyebrow="Account" title="Change password" />

      <div className="card">
        <form onSubmit={handleSubmit} className="login-form">
          <label className="input-label">Current password
            <input
              type="password"
              className="input"
              autoComplete="current-password"
              value={oldPass}
              onChange={e => setOldPass(e.target.value)}
              required
            />
          </label>
          <label className="input-label">New password
            <input
              type="password"
              className="input"
              autoComplete="new-password"
              value={newPass}
              onChange={e => setNewPass(e.target.value)}
              required
            />
          </label>
          <label className="input-label">Confirm new password
            <input
              type="password"
              className="input"
              autoComplete="new-password"
              value={confirmPass}
              onChange={e => setConfirmPass(e.target.value)}
              required
            />
          </label>
          {msg && (
            <div className={msg.includes('successfully') ? 'alert success' : 'alert error'}>{msg}</div>
          )}
          <button className="btn login-submit" type="submit" disabled={loading}>
            {loading ? 'Updating' : 'Change password'}
          </button>
        </form>
      </div>
    </div>
  );
}
